function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("g", {
  fill: "#004152",
  transform: "translate(4 2)"
}, React.createElement("circle", {
  cx: 8.49,
  cy: 3.71,
  r: 3.71
}), React.createElement("path", {
  d: "M8.22 8.89c-.29 1.66-.57 4.66-.57 4.66H8.9l-.59-4.7c.95-.51 1.73-.85 2.4-1.2 1.23 0 6.79 3.7 5.55 4.94-1.24 1.85-1.85.62-4.32-1.24.19 1.6.2 2.95.62 4.32.99 1.2 1.66 1.55 2.67 3.07.82 1.26.64 1.77-.26 2.44-1.17.87-3.11-1.07-3.03-1.18-.65-.59-1.33-1-1.85-1.24-1.24-.62-4.13-.47-5.56 1.24.07.1-1.03.7-1.06.78-.7.47-1.31.53-1.94.24-.58-.26-.9-1.7-.58-2.33.49-1.43 2.1-1.98 2.96-3.01.32-1.44.36-3.35.62-4.33C2.67 12.6 1.43 14.46.2 12.6c-1.24-1.23 3.7-4.32 4.94-4.94 1.85.62 1.58.52 3.08 1.24z"
}));

var SvgChild = function SvgChild(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChild, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/child.4964dfbf.svg";
export { ForwardRef as ReactComponent };